export const SET_HOME_DATA_ACTION = 'app/HomeView/SET_HOME_DATA_ACTION';
